/**
 * DEPRECATED compat shim (M5 S5.1.2).
 *
 * Old imports of `AuthGuard` keep working but now follow Admin RBAC:
 * memory-session via useAuthStore (no localStorage), anon → /admin/login,
 * disabled → /admin/disabled. New code should import AdminAuthGuard directly.
 */
import { ReactNode, useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/admin/auth/useAuthStore';
import { fetchMe } from '@/admin/api/adminAuth.service';

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const status = useAuthStore((s) => s.status);
  const admin = useAuthStore((s) => s.admin);
  const location = useLocation();
  const fetchAttempted = useRef(false);

  useEffect(() => {
    if (import.meta.env.DEV) {
       
      console.warn('[deprecated] AuthGuard → use AdminAuthGuard for new routes');
    }
    // Delegate to the admin session: hydrate memory session once when idle
    // (mirrors AdminAuthGuard's fetchMe-once; idle/loading render null below).
    if (!fetchAttempted.current && useAuthStore.getState().status === 'idle') {
      fetchAttempted.current = true;
      fetchMe().catch(() => undefined);
    }
  }, []);

  if (status === 'idle' || status === 'loading') {
    return (
      <div className="flex items-center justify-center min-h-screen" role="status" aria-live="polite">
        <span className="sr-only">Loading...</span>
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }
  if (status === 'disabled' || admin?.status === 'disabled') {
    return <Navigate to="/admin/disabled" replace />;
  }
  if (status !== 'authed' || !admin) {
    return (
      <Navigate
        to={`/admin/login?next=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }
  return <>{children}</>;
}
